import { FC, memo, useEffect, useMemo, useState } from 'react';
import { Badge, Col, Empty, Row, Space, Typography } from 'antd';
// import { Line, Pie } from '@ant-design/charts';
import { useTranslation } from 'react-i18next';
import {
  AppointmentStatistics,
  fetchAppointmentStatistics,
  sumGender
} from 'services/api/statistics';

import CountCard from '../CountCard';
import { Loading } from 'components/ui';

const { Title } = Typography;

const Statistics: FC = () => {
  const { t } = useTranslation();
  const [result, setResult] = useState<AppointmentStatistics | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAppointmentStatistics()
      .then(setResult)
      .catch(() => setResult(null))
      .finally(() => setLoading(false));
  }, []);

  const patientsCount = useMemo(() => {
    const { male, female } = sumGender(result?.gender);

    return male + female;
  }, [result?.gender]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div>
      <Title style={{ display: 'inline-block' }} level={4}>
        {t('dashboard.statistics')}
      </Title>
      {result?.appointmentsCount ? (
        <Row gutter={[32, 32]} align="stretch" wrap>
          <Col xs={24} md={12}>
            <CountCard
              title={t('dashboard.appointments')}
              count={result.appointmentsCount || 0}
              to="/appointments"
            >
              <Space>
                <Badge color="#88B5FF" text="20 (MedicusUnion)" />
                <Badge color="#35B678" text="12 (Personal)" />
              </Space>
            </CountCard>
          </Col>
          <Col xs={24} md={12}>
            <CountCard
              title={t('dashboard.patients')}
              count={patientsCount}
              to="/patients"
            >
              <Space>
                <Badge color="#88B5FF" text="20 (MedicusUnion)" />
                <Badge color="#35B678" text="12 (Personal)" />
              </Space>
            </CountCard>
          </Col>
        </Row>
      ) : (
        <Empty />
      )}
    </div>
  );
};

export default memo(Statistics);
